import { createRoute } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import { BarChart3 } from "lucide-solid";
import { appRoute } from "./route";
import { PageContainer } from "@/components/ui/page-container";
import { useI18n } from "@/providers/i18n-provider";
import { useActiveOrg } from "@/features/academy/hooks/use-active-org";
import { AcademyMetricsSections } from "@/features/academy/metrics/dashboard";

function AcademyDashboardPage() {
  const { t } = useI18n();
  const { activeOrgId, activeOrg } = useActiveOrg();

  return (
    <PageContainer maxWidth="6xl">
      <div class="space-y-6">
        <div class="flex items-center gap-3">
          <BarChart3 class="h-8 w-8 text-primary" />
          <div>
            <h2 class="text-3xl font-bold tracking-tight">{t(msg`Academy dashboard`)}</h2>
            <p class="text-sm text-muted-foreground">
              {activeOrg()?.name ??
                t(msg`Enrollment, revenue, debt, attendance and academic performance.`)}
            </p>
          </div>
        </div>
        <AcademyMetricsSections orgId={activeOrgId} />
      </div>
    </PageContainer>
  );
}

export const academyIndexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy",
  component: AcademyDashboardPage,
});
